import { BaseFilter } from '@/hooks/usePaginationFilter';

type FormatUrlWithFilters = <T extends BaseFilter>(baseUrl: string, filter: T) => string;

export const formatUrlWithFilters: FormatUrlWithFilters = (baseUrl, filter) => {
  const { limit, offset, ...otherFilters } = filter;
  const cleanedFilters = Object.entries(otherFilters).reduce(
    (acc, [key, value]) => {
      if (Array.isArray(value)) {
        const nonEmptyValues = value.filter((v): v is string => typeof v === 'string' && v !== '');
        if (nonEmptyValues.length > 0) {
          acc[key] = nonEmptyValues;
        }
      } else if (typeof value === 'string' && value !== '') {
        acc[key] = value;
      } else if (typeof value === 'boolean') {
        // Handle boolean values
        acc[key] = value;
      } else if (value !== null && value !== undefined) {
        // Handle other non-empty values like numbers
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string | string[] | boolean | number | any>,
  );

  const transformedFilters = Object.entries(cleanedFilters).reduce(
    (acc, [key, value]) => {
      acc[key] = Array.isArray(value) ? value.map(String) : [String(value)];
      return acc;
    },
    {} as Record<string, string[]>,
  );

  const queryParams = new URLSearchParams();
  queryParams.append('offset', String(offset));
  queryParams.append('limit', String(limit));
  if (Object.keys(transformedFilters).length > 0) {
    queryParams.append('filters', JSON.stringify(transformedFilters));
  }

  return `${baseUrl}?${queryParams.toString()}`;
};

export const getQueryParamsURL = (url: string, params: any) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    queryParams.append(key, params[key]);
  });

  return `${url}?${queryParams.toString()}`;
};

export const formatUrlWithQueryParams = <T extends Record<string, any>>(url: string, params: T) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null && v !== '') {
          queryParams.append(key, String(v));
        }
      });
    } else if (typeof value === 'boolean') {
      queryParams.append(key, value ? 'true' : 'false');
    } else {
      queryParams.append(key, String(value));
    }
  });

  const qs = queryParams.toString();
  return qs ? `${url}?${qs}` : url;
};
